import BaseClient from './BaseClient';

class AdminContactsClient extends BaseClient {
    contactReset(teamId, contactId) {
        const url = `/api/admin/teams/${teamId}/contacts/${contactId}/reset`;
        return this.makeCoreApiRequest(url, 'post');
    }
}

export default new AdminContactsClient();
